import React from "react";

import { Button, LabeledField, SectionCard, TextInput } from "shared/ui";

import { API_KEY_HINT } from "features/IikoIntegration/constants";
import { useIikoIntegrationContext } from "features/IikoIntegration/context";

import { Action, Field, Row } from "./styles";

/*
* Первый шаг мастера. Ключ сохраняется только по кнопке: его проверяет бэк (запрашивает токен
* у iiko), и делать это на каждый введённый символ нельзя.
* */
export const ApiKeyStep = () => {
    const state = useIikoIntegrationContext();

    const saving = state.saving.apiLogin;
    const isEditingSaved = !!state.apiLogin;

    return (
        <SectionCard title="Ключ Iiko Transport" description={API_KEY_HINT}>
            <LabeledField
                label="Ключ"
                htmlFor="iiko-api-login"
                hint="После сохранения подтянем список организаций"
            >
                <Row>
                    <Field>
                        <TextInput
                            id="iiko-api-login"
                            value={state.apiLoginDraft}
                            placeholder="Вставьте ключ из iiko"
                            disabled={saving}
                            onChange={state.setApiLoginDraft}
                        />
                    </Field>

                    <Action>
                        <Button
                            variant="contained"
                            disabled={saving || !state.apiLoginDraft.trim()}
                            onClick={state.submitApiLogin}
                        >
                            {saving
                                ? "Сохраняем…"
                                : isEditingSaved
                                ? "Сохранить"
                                : "Проверить и сохранить"}
                        </Button>

                        {/* Ключ уже сохранён — значит шаг открыт по «Изменить», и его нужно
                            уметь закрыть, не трогая рабочее подключение. */}
                        {isEditingSaved && (
                            <Button
                                variant="text"
                                color="neutral"
                                disabled={saving}
                                onClick={state.cancelApiLoginEditing}
                            >
                                Отмена
                            </Button>
                        )}
                    </Action>
                </Row>
            </LabeledField>
        </SectionCard>
    );
};
